import { css } from '@emotion/core';
import { MediaQueries } from '../../../../../styles/Grid';
import { ColumnPadding } from '../../../../../styles/Grid/GridSizes';
import { fontWeights } from '../../../../../styles/typography';

export const form = css({
  width: '100%',
});

export const checkboxContainer = css({
  padding: `0 ${ColumnPadding.sm}px`,
  [MediaQueries.mdAndUp]: {
    padding: `0 ${ColumnPadding.md}px`,
  },
  [MediaQueries.lgAndUp]: {
    display: 'flex',
    padding: 0,
  },
  strong: {
    fontWeight: fontWeights.medium,
  },
});

export const checkbox = css({
  [MediaQueries.lgAndUp]: {
    flex: '1 1',
    margin: `0 ${ColumnPadding.lg}px`,
  },
});
